import { Box, Container, Grid, Typography, alpha } from '@mui/material';
import { motion } from 'framer-motion';

const P = {
  main: '#1e40af',
  light: '#3b82f6',
  dark: '#1e3a8a',
  accent: '#0891b2',
};

const audiences = [
  {
    image: '/assets/icon/association.webp',
    title: 'Klasik Dernekler',
    description: 'Üye, aidat ve yönetim süreçlerini düzenli şekilde yönetin.',
    color: '#f97316',
  },
  {
    image: '/assets/icon/clubs.webp',
    title: 'Eğitim & Öğrenci Dernekleri',
    description: 'Etkinlik, duyuru ve iletişim süreçlerini kolayca yönetin.',
    color: '#0891b2',
  },
  {
    image: '/assets/icon/vakif.webp',
    title: 'STK & Vakıflar',
    description: 'Şeffaflık, raporlama ve bağış yönetimi odaklı yapı.',
    color: '#8b5cf6',
  },
  {
    image: '/assets/icon/football-club.webp',
    title: 'Spor Kulüpleri',
    description: 'Üye takibi, organizasyon ve finans süreçleri tek panelde.',
    color: '#10b981',
  },
  {
    image: '/assets/icon/public-associations.webp',
    title: 'Meslek Odaları',
    description: 'Yetkilendirme, belge ve üye ilişkileri için kurumsal çözüm.',
    color: '#3b82f6',
  },
  {
    image: '/assets/icon/conference.webp',
    title: 'Dini / Sosyal Yapılar',
    description: 'Topluluk yönetimi, duyuru ve bağış süreçlerini dijitale taşıyın.',
    color: '#f43f5e',
  },
];

const AudienceCard = ({ item, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
    viewport={{ once: true, margin: '-50px' }}
    style={{ height: '100%' }}
  >
    <Box
      sx={{
        height: '100%',
        p: 4,
        borderRadius: 3,
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        transition: 'all 0.3s ease',
        cursor: 'default',
        '&:hover': {
          transform: 'translateY(-6px)',
          boxShadow: `0 12px 32px ${alpha(item.color, 0.15)}`,
          borderColor: alpha(item.color, 0.3),
        },
      }}
    >
      {/* Icon Box */}
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: 3,
          background: `linear-gradient(135deg, ${item.color} 0%, ${alpha(item.color, 0.8)} 100%)`,
          boxShadow: `0 8px 20px ${alpha(item.color, 0.25)}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
          transition: 'transform 0.3s ease',
          '&:hover': {
            transform: 'scale(1.05)',
          },
        }}
      >
        <Box
          component="img"
          src={item.image}
          alt={item.title}
          sx={{
            width: '60%',
            height: '60%',
            objectFit: 'contain',
            filter: 'brightness(0) invert(1)',
          }}
        />
      </Box>

      {/* Başlık */}
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: '1.1rem',
          color: '#1e293b',
          mb: 1.5,
          letterSpacing: '-0.01em',
          lineHeight: 1.3,
        }}
      >
        {item.title}
      </Typography>

      {/* Açıklama */}
      <Typography
        sx={{
          color: '#64748b',
          fontSize: '0.9rem',
          lineHeight: 1.7,
        }}
      >
        {item.description}
      </Typography>
    </Box>
  </motion.div>
);

const WhoIsItForSectionKurumsal = () => {
  return (
    <Box
      sx={{
        py: { xs: 10, md: 14 },
        background: 'linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background decoration */}
      <Box
        sx={{
          position: 'absolute',
          top: '-10%',
          right: '-5%',
          width: 500,
          height: 500,
          borderRadius: '50%',
          background: `radial-gradient(circle, ${alpha(P.main, 0.06)} 0%, transparent 70%)`,
          filter: 'blur(60px)',
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                px: 3,
                py: 1,
                borderRadius: 50,
                background: alpha(P.main, 0.08),
                border: `1px solid ${alpha(P.main, 0.15)}`,
                mb: 3,
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  background: P.main,
                }}
              />
              <Typography
                sx={{
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  color: P.main,
                  letterSpacing: '0.5px',
                }}
              >
                KİMLER İÇİN UYGUN
              </Typography>
            </Box>

            <Typography
              sx={{
                fontSize: { xs: '2.4rem', md: '2.8rem' },
                fontWeight: 800,
                color: '#1e293b',
                letterSpacing: '-0.02em',
                mb: 2,
                lineHeight: 1.2,
              }}
            >
              Hangi Dernekler İçin Uygun?
            </Typography>
            <Typography
              sx={{
                color: '#64748b',
                fontSize: { xs: '1rem', md: '1.1rem' },
                maxWidth: 600,
                mx: 'auto',
                lineHeight: 1.7,
              }}
            >
              Her dernek türü için aynı sistem değil, ihtiyaca göre özelleştirilebilen 
              güçlü altyapı.
            </Typography>
          </Box>
        </motion.div>

        {/* Grid - 2x3 */}
        <Grid container spacing={3}>
          {audiences.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <AudienceCard item={item} index={index} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhoIsItForSectionKurumsal;
